import { _isLessOrEqual, _times } from '@/helpers/bigNumber'

const Mb = 1048576

export default {
  getMessage (field, args) {
    return field
  },
  validate (value, args) {
    return _isLessOrEqual(value.size, _times(args[0], Mb))
  }
}
